import { render, staticRenderFns } from "./EspeciesInstitucional.vue?vue&type=template&id=65ef0bb5&"
import script from "./EspeciesInstitucional.vue?vue&type=script&lang=js&"
export * from "./EspeciesInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports